import { SetVerificationStatusButton } from './SetVerificationStatusButton';

export default SetVerificationStatusButton;
